import React            from 'react';
import { Observe }           from 'rewire-core';
import {
  FormView,
  Form,
  Modal,
}                            from 'rewire-ui';
import classNames            from 'classnames';
import Divider               from '@material-ui/core/Divider';
import { Theme, makeStyles } from '../utility/styles';
import FormButtons           from './FormButtons';
import { If }                from './SettingsModel';

const formFieldsStyles = (_theme: Theme) => ({
  fieldContainer: {
  },
});

const useFormFieldStyles = makeStyles(formFieldsStyles);
export const FormFields  = React.memo(({ form, classes }: { form: Form, classes?: any }) => {
  const formFieldsClasses = useFormFieldStyles({classes});
  return (
    <Observe>{() => (
      <>{form.fields.map((field) =>
        <If key={field.name} condition={field.visible} then={
          <div key={field.name} className={classNames('content', formFieldsClasses.fieldContainer)}>
            <field.Editor className='span1' />
          </div>
        } />
      )}
      </>)}
    </Observe>
  );
});

const formStyles = (_theme: Theme) => ({
  form: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  fields: {
    flex: 1,
    overflowY: 'auto',
  },
  viewTabsRoot: {
    margin: '0px 0px 10px 0px',
    padding: '10px 0px',
  },
  fieldContainer: {
  },
  formButtonsRoot: {
  },
  formButtonsButton: {
  },
});

export const useFormStyles = makeStyles(formStyles);
export default React.memo(({ editor, actions, classes, submit }: { editor: {form: Form, visible: boolean} & Modal<any>, actions?: string[], classes?: any, submit?: string }) => {
  const formClasses = useFormStyles({classes});
  return (
    <FormView form={editor.form} className={formClasses.form} onSubmit={editor.actions[submit ?? 'save'].action}>
      <div className={formClasses.fields}>
        <Observe>{() => (
          editor.visible && <FormFields form={editor.form} classes={{fieldContainer: formClasses.fieldContainer}} />
        )}</Observe>
      </div>
      {actions && (
        < >
        <Divider />
        <FormButtons modal={editor} actions={actions} classes={{root: formClasses.formButtonsRoot, button: formClasses.formButtonsButton}} />
        </>
      )}
    </FormView>
  );
});
